import React from 'react'
import {Link} from 'react-router'

export default function FergusLogs() {
    return <div>
      <h2>Fergus Logs</h2>
      <ul>
        <li>
          <Link to="/fergus-logs/supplier-documents">Supplier Document Logs</Link>
        </li>
      </ul>
    </div>
}



// WEBPACK FOOTER //
// ./app/pages/FergusLogs/index.js